<template>
  <div>
  <PrintBadgeForm :selectedUsersForPrint="usersForPrint" />
  

    <div class="massaction-page-title-container">
      <p class="massaction-page-title">
        {{ $t("common.signInAndOut") }} ({{
          `${multipleUsersData.site_name} - ${multipleUsersData.area.name}`
        }}
        )
      </p>
      <button
        v-if="isMultipleUserType"
        :disabled="!enableNextMultipleUserTypeBtn"
        class="next-user-type-btn"
        @click="nextUserTypeHandler"
      >
        {{ $t("signInOut.nextType") }}
      </button>
    </div>
    <section class="multipleSigninAction">
      <div class="page-container">
        <!-- start::table -->
        <md-table v-model="tableData">
          <template v-if="enableNextMultipleUserTypeBtn">
            <p class="multiple-users-success-note">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#34C38F"
                  d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9Z"
                />
              </svg>
              {{ $t("signInOut.successActionMsg") }}
            </p>
          </template>
          <template v-else>
            <button
              :disabled="
                disableMassActionButton || showRowStatus || checkIfInvalid
              "
              class="apply-btn"
              @click="massActionSignInHandler"
              style="visibility: hidden"
            >
              {{ $t("signInOut.applyForAll") }}
            </button>
          </template>
          <!-- start::table header -->
          <md-table-toolbar class="my-2">
            <template v-if="enableNextMultipleUserTypeBtn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="margin: 0 8px"
              >
                <path
                  fill="#34C38F"
                  d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9Z"
                />
              </svg>
              <p class="multiple-users-success-note">
                {{ $t("signInOut.successActionMsg") }}
              </p>
            </template>
            <template v-else>
              <p class="page-header">
                {{ multipleUsersData.users.length - 1 }}
                <template v-if="multipleUsersData.users.length - 1 > 1">
                  {{ $t("users.form.usersSelected") }}
                </template>
                <template v-else>
                  {{ $t("users.form.userSelected") }}
                </template>
                ({{ multipleUsersData.user_type.name }})
              </p>

              <button
                :disabled="
                  disableMassActionButton || showRowStatus || checkIfInvalid
                "
                class="apply-btn"
                :class="{ 'full-opacity': massActionIsStarted }"
                @click="massActionSignInHandler"
              >
                <b-spinner
                  v-if="massActionIsStarted"
                  class="apply-for-all-spinner"
                />
                <template v-else>{{ $t("signInOut.applyForAll") }}</template>
              </button>
            </template>
          </md-table-toolbar>
          <!-- end::table header -->

          <md-table-row slot="md-table-row" slot-scope="{ item, index }">
            <!----------------------------------- start:: All action -------------------------------------->
            <template v-if="item.all">
              <md-table-cell
                :md-label="$t('common.user')"
                class="default-text-style"
                >{{ $t("signInOut.all") }}
              </md-table-cell>
              <md-table-cell
                :md-label="$t('common.notes.notes')"
                v-if="showNoteColumnTemp"
              >
              </md-table-cell>
              

              <!-- start:: Temperature/Mask -->
              <md-table-cell
                v-if="showChecksColumnTemp"
                :md-label="checksColumnName"
              >
                <template v-if="item.showChecksFillinButton">
                  <button
                    :disabled="massActionIsStarted"
                    class="fillin-btn"
                    @click="actionModalHandler(item.checksModel)"
                  >
                    {{ $t("signInOut.fillIn") }}
                  </button>
                </template>
                <template v-else> - </template>
              </md-table-cell>
              <!-- end:: Temperature/Mask -->

              <!-- start:: Error-->
              <md-table-cell :md-label="$t('common.error')"></md-table-cell>
              <!-- end:: Error-->

              <!-- start:: Admin Notes-->
              <md-table-cell :md-label="$t('signInOut.adminNotes')"
                ><button
                  :disabled="massActionIsStarted"
                  class="fillin-btn"
                  @click="
                    adminNotesModalHandler({
                      adminNotes: '',
                      isMandatory: checkIfAtleastOneUserHasError(),
                      allAction: true,
                    })
                  "
                >
                  {{ $t("common.add") }}
                </button>
              </md-table-cell>
              <!-- end:: Admin Notes-->

              <!-- start:: Host-->
              <md-table-cell
                v-if="showHostColumnTemp"
                :md-label="$t('common.host')"
              >
                <template v-if="displayHostMasActionAddButton">
                  <button
                    :disabled="massActionIsStarted"
                    class="fillin-btn"
                    @click="actionModalHandler(item.hostModel)"
                  >
                    {{ $t("common.add") }}
                  </button>
                </template>
                <template v-else> - </template>
              </md-table-cell>
              <!-- end:: Host-->

              <!-- start:: Sections -->
              <md-table-cell
                v-for="section in item.sections"
                :key="section.id"
                :md-label="`${section.name} (${
                  section.type == 0
                    ? $t('signInOut.profile')
                    : $t('common.visit')
                })`"
              >
              </md-table-cell>
              <!-- end:: Sections -->

              <!-- start:: Late Sign-in Reason -->
              <md-table-cell
                v-if="item.showLateSignInReason"
                :md-label="$tc('signInOut.lateSignin', 1)"
                class="vp-width-171 vp-pa-0 reason-cell"
              >
                <vp-multiselect
                  class="valid-multiselect"
                  v-model="
                    $v.tableData.$each.$iter[index].lateSignInReason.$model
                  "
                  :options="item.lateSignInReasonsOptions"
                  placeholder="Select..."
                  label="name"
                  :width="
                    $v.tableData.$each.$iter[index].lateSignInReason.$error
                      ? '175'
                      : '171'
                  "
                  backgroundColor="#FFFFFF"
                  :allowEmpty="true"
                  :showOptionsBorder="true"
                  :zIndex="(tableData.length - index).toString()"
                  :disabled="massActionIsStarted"
                  @input="lateSignInMassAction"
                  @open="onMultiselectOpen(item.lateSignInReasonsOptions)"
                  @close="onMultiselectClose"
                />
              </md-table-cell>
              <!-- end:: Late Sign-in Reason -->

              <!-- start::Early Sign-out Reason -->
              <md-table-cell
                v-if="item.showEarlySignOutReason"
                :md-label="$tc('signInOut.earlySignOut', 1)"
                class="vp-width-171 vp-pa-0 reason-cell early-sign-out-cell"
              >
                <vp-multiselect
                  class="valid-multiselect"
                  v-model="
                    $v.tableData.$each.$iter[index].earlySignOutReason.$model
                  "
                  :options="item.earlySignOutReasonsOptions"
                  placeholder="Select..."
                  label="name"
                  :width="
                    $v.tableData.$each.$iter[index].lateSignInReason.$error
                      ? '175'
                      : '171'
                  "
                  backgroundColor="#FFFFFF"
                  :allowEmpty="true"
                  :showOptionsBorder="true"
                  :zIndex="(tableData.length - index).toString()"
                  :disabled="massActionIsStarted"
                  @input="earlySignOutMassAction"
                  @open="onMultiselectOpen(item.earlySignOutReasonsOptions)"
                  @close="onMultiselectClose"
                />
              </md-table-cell>
              <!-- end::Early Sign-out Reason -->

              <!-- start:: Compliances -->
              <md-table-cell
                v-for="compliance in item.complinaces"
                :key="compliance.name"
                :md-label="compliance.name"
              >
                <template v-if="compliance.isRequired">
                  <button
                    :disabled="massActionIsStarted"
                    class="fillin-btn"
                    @click="actionModalHandler(compliance)"
                  >
                    {{ $t("signInOut.fillIn") }}
                  </button>
                </template>
                <template v-else>-</template>
              </md-table-cell>
              <!-- end:: Compliances -->

              <!-- start:: Document -->
              <md-table-cell
                v-if="item.documents && item.documents.length"
                :md-label="
                  item.documents[0].isOptional
                    ? `${item.documents[0].complianceDocument[0].name} ${$t(
                        'common.optionalWithBrackets'
                      )}`
                    : `${item.documents[0].complianceDocument[0].name}`
                "
              >
                <template
                  v-if="item.documents[0] && item.documents[0].isRequired"
                >
                  <button
                    @click="actionModalHandler(item.documents[0])"
                    class="fillin-btn"
                    :disabled="massActionIsStarted"
                  >
                    {{ $t("signInOut.fillIn") }}
                  </button></template
                >
                <template v-else> - </template>
              </md-table-cell>
              <!-- end:: Document -->

              <md-table-cell
                class="print-badge-cell"
                :md-label="$t('journeyBuilder.flow.printBadge')"
                v-if="showPrintBadgeColumn"
              >
                <b-form-checkbox
                  class="switch-gray custom-switch-input"
                  switch
                  size="lg"
                  :disabled="massActionIsStarted"
                  v-model="item.printBadge"
                  @change="printBadgeForAllChanged($event)"
                ></b-form-checkbox>
              </md-table-cell>

              <!-- start:: Status -->
              <md-table-cell :md-label="$t('common.status')"> </md-table-cell>
              <!-- end:: Status -->
            </template>
            <!----------------------------------- end:: All action ------------------------------------------->

            <!----------------------------------- start:: Single action -------------------------------------->
            <template v-else>
              <!-- start::  fullname -->
              <md-table-cell
                style="min-width: 200px"
                class="default-text-style"
                :md-label="$t('common.user')"
                >{{ item.full_name }}</md-table-cell
              >
              <!-- end:: fullname -->

              <!-- start:: Note -->
              <md-table-cell
                class="default-text-style"
                style="min-width: 400px"
                v-if="showNoteColumnTemp"
                :md-label="$t('common.notes.notes')"
              >
                <ul v-if="item.notes && item.notes.length">
                  <li v-for="note in item.notes" :key="note">
                    <p class="default-text-style">{{ note }}</p>
                  </li>
                </ul>
                <p
                  v-else
                  class="d-flex flex-column justify-content-center cell-min-height"
                >
                  -
                </p>
              </md-table-cell>
              <!-- end:: Note -->

              <!-- start:: Temperature/Mask -->
              <md-table-cell
                v-if="showChecksColumnTemp"
                :md-label="checksColumnName"
              >
                <template v-if="!item.signedOut"
                  ><p
                    class="d-flex flex-column justify-content-center cell-min-height"
                  >
                    -
                  </p></template
                >
                <template v-else>
                  <template v-if="item.checksModel && item.checksModel.isDirty">
                    <p
                      class="checks-value"
                      v-if="
                        item.checksModel?.temperature || item.checksModel?.mask
                      "
                    >
                      <template v-if="item.checksModel?.temperature"
                        >
                        {{
                          `${
                            item.checksModel?.temperature.currentValue
                          } ${ item.checksModel?.temperature.unitType == "c" ? $t('common.temperatureUnits.c').charAt(0).toUpperCase() : 
                            $t('common.temperatureUnits.f').charAt(0).toUpperCase()} `
                        }}
                      </template>
                      <template
                        v-if="
                          item.checksModel?.temperature && item.checksModel?.mask
                        "
                        >/</template
                      >
                      <template v-if="item.checksModel?.mask">
                        {{
                          item.checksModel?.mask.currentValue
                            ? $tc("signInOut.maskStatus", 2)
                            : $tc("signInOut.maskStatus", 1)
                        }}
                      </template>
                    </p>
                  </template>
                  <button
                    :disabled="massActionIsStarted"
                    class="fillin-btn"
                    :class="{
                      'vp-mb-10':
                        item.checksModel?.temperature || item.checksModel?.mask,
                    }"
                    @click="actionModalHandler(item.checksModel)"
                  >
                    {{
                      item.checksModel && item.checksModel.isDirty
                        ? $t("common.update")
                        : $t("signInOut.fillIn")
                    }}
                  </button>
                </template>
              </md-table-cell>
              <!-- end:: Temperature/Mask -->

              <!-- start:: Error-->

              <md-table-cell
                :md-label="$t('common.error')"
                class="default-text-style"
                :class="{ 'w-480': item.errors && item.errors.length }"
              >
                <ul
                  v-if="item.errors && item.errors.length"
                  class="single-action-errors-list"
                >
                  <li v-for="error in item.errors" :key="error">
                    <p class="error-text-style">
                      {{ error }}
                    </p>
                  </li>
                </ul>
                <p
                  v-else
                  class="d-flex flex-column justify-content-center cell-min-height"
                >
                  <span>-</span>
                </p>
              </md-table-cell>
              <!-- end:: Error-->

              <!-- start:: Admin Notes-->
              <md-table-cell
                class="default-text-style"
                :md-label="$t('signInOut.adminNotes')"
              >
                <p v-if="item.adminNotes.notes" class="vp-mt-13 vp-mb-10">
                  {{ item.adminNotes.notes }}
                </p>
                <button
                  :disabled="massActionIsStarted"
                  class="fillin-btn"
                  :class="{ 'vp-mb-10': item.adminNotes.isDirty }"
                  @click="
                    adminNotesModalHandler({
                      adminNotes: item.adminNotes,
                      isMandatory:
                        item.errors && item.errors.length ? true : false,
                      user_id: item.id,
                    })
                  "
                >
                  {{
                    item.adminNotes.isDirty
                      ? $t("common.update")
                      : $t("common.add")
                  }}
                </button>
              </md-table-cell>
              <!-- end:: Admin Notes-->

              <!-- start:: Host-->
              <md-table-cell
                style="min-width: 280px"
                v-if="showHostColumnTemp"
                :md-label="$t('common.host')"
              >
                <p
                  class="host-value"
                  v-if="
                    item.hostModel &&
                    item.hostModel.selectedHost &&
                    item.hostModel.selectedHost.name &&
                    item.hostModel.isDirty
                  "
                >
                  {{ item.hostModel.selectedHost.name.userName_with_userType }}
                </p>
                <p
                  class="host-value"
                  v-else-if="item.hostModel && item.hostModel.no_host_selected"
                >
                  {{
                    item.hostModel.hostMessage ||
                    "I don’t know the visitor’s host"
                  }}
                </p>
                <template v-if="!item.signedOut">
                  <p
                    class="d-flex flex-column justify-content-center cell-min-height"
                  >
                    -
                  </p>
                </template>
                <template v-else>
                  <button
                    :disabled="massActionIsStarted"
                    class="fillin-btn"
                    :class="{ 'vp-mb-10': item.hostModel.isDirty }"
                    @click="actionModalHandler(item.hostModel)"
                  >
                    {{
                      item.hostModel.isDirty
                        ? $t("common.update")
                        : $t("common.add")
                    }}
                  </button>
                </template>
              </md-table-cell>
              <!-- end:: Host-->

              <!-- start:: Sections -->
              <md-table-cell
                v-for="section in item.sections"
                :key="section.id"
                :md-label="`${section.name} (${
                  section.type == 0
                    ? $t('signInOut.profile')
                    : $t('common.visit')
                })`"
                style="min-width: 190px"
              >
                <template v-if="section.readOnly">
                  <p
                    class="d-flex flex-column justify-content-center cell-min-height vp-font-weight-400"
                  >
                    -
                  </p>
                </template>

                <template v-else>
                  <p class="section-field" v-if="section.isFilled">
                    {{ $t("signInOut.sectionUpdated") }}.
                  </p>

                  <button
                    :disabled="massActionIsStarted"
                    @click="actionModalHandler(section, item.id)"
                    :class="{ 'vp-mb-10': section.isFilled }"
                    class="fillin-btn"
                  >
                    {{
                      section.isFilled ? $t("common.update") : $t("common.add")
                    }}
                  </button>
                </template>
              </md-table-cell>

              <!-- start:: Late Sign-in Reason -->
              <md-table-cell
                v-if="tableData[0].showLateSignInReason"
                :md-label="$tc('signInOut.lateSignin', 1)"
                class="vp-width-171 vp-pa-0 reason-cell"
              >
                <b-tooltip
                  v-if="$v.tableData.$each.$iter[index].lateSignInReason.$error"
                  :target="'late-sign-in-reason' + item.id"
                  triggers="focus"
                  variant="danger"
                  placement="top"
                >
                  {{ $t("signInOut.requiredReason") }}
                </b-tooltip>

                <template v-if="item.showLateSignInReason">
                  <vp-multiselect
                    :class="{
                      'invalid-multiselect':
                        $v.tableData.$each.$iter[index].lateSignInReason.$error,
                      'valid-multiselect':
                        !$v.tableData.$each.$iter[index].lateSignInReason
                          .$error,
                    }"
                    :id="'late-sign-in-reason' + item.id"
                    v-model="
                      $v.tableData.$each.$iter[index].lateSignInReason.$model
                    "
                    :options="item.lateSignInReasonsOptions"
                    placeholder="Select..."
                    label="name"
                    :width="
                      $v.tableData.$each.$iter[index].lateSignInReason.$error
                        ? '175'
                        : '171'
                    "
                    backgroundColor="#FFFFFF"
                    :allowEmpty="true"
                    :showOptionsBorder="true"
                    :zIndex="(tableData.length - index).toString()"
                    :disabled="massActionIsStarted"
                    @input="checkMassActionLateSignInReason"
                    @open="onMultiselectOpen(item.lateSignInReasonsOptions)"
                    @close="onMultiselectClose"
                  />
                </template>
                <template v-else>
                  <p
                    class="d-flex flex-column justify-content-center cell-min-height vp-mt-9 vp-ml-27"
                  >
                    -
                  </p>
                </template>
              </md-table-cell>
              <!-- end:: Late Sign-in Reason -->

              <!-- start::Early Sign-out Reason -->
              <md-table-cell
                v-if="tableData[0].showEarlySignOutReason"
                :md-label="$tc('signInOut.earlySignOut', 1)"
                class="vp-width-171 vp-pa-0 reason-cell early-sign-out-cell"
              >
                <b-tooltip
                  v-if="
                    $v.tableData.$each.$iter[index].earlySignOutReason.$error
                  "
                  :target="'early-sign-out-reason' + item.id"
                  triggers="focus"
                  variant="danger"
                  placement="top"
                >
                  {{ $t("signInOut.requiredReason") }}
                </b-tooltip>

                <template v-if="item.showEarlySignOutReason">
                  <vp-multiselect
                    :class="{
                      'invalid-multiselect':
                        $v.tableData.$each.$iter[index].earlySignOutReason
                          .$error,
                      'valid-multiselect':
                        !$v.tableData.$each.$iter[index].earlySignOutReason
                          .$error,
                    }"
                    :id="'early-sign-out-reason' + item.id"
                    v-model="
                      $v.tableData.$each.$iter[index].earlySignOutReason.$model
                    "
                    :options="item.earlySignOutReasonsOptions"
                    placeholder="Select..."
                    label="name"
                    :width="
                      $v.tableData.$each.$iter[index].lateSignInReason.$error
                        ? '175'
                        : '171'
                    "
                    backgroundColor="#FFFFFF"
                    :allowEmpty="true"
                    :showOptionsBorder="true"
                    :zIndex="(tableData.length - index).toString()"
                    :disabled="massActionIsStarted"
                    @input="checkMassActionEarlySignOutReason"
                    @open="onMultiselectOpen(item.earlySignOutReasonsOptions)"
                    @close="onMultiselectClose"
                  />
                </template>
                <template v-else>
                  <p
                    class="d-flex flex-column justify-content-center cell-min-height vp-mt-9 vp-ml-27"
                  >
                    -
                  </p>
                </template>
              </md-table-cell>
              <!-- end::Early Sign-out Reason -->

              <!-- start:: Compliances -->
              <md-table-cell
                v-for="compliance in item.complinaces"
                :key="compliance.id"
                :md-label="compliance.name"
              >
                <template v-if="!item.signedOut"
                  ><p
                    class="d-flex flex-column justify-content-center cell-min-height"
                  >
                    -
                  </p></template
                >
                <template v-else>
                  <template
                    v-if="
                      compliance.isRequired ||
                      compliance.form_metadata.isExpected
                    "
                  >
                    <p
                      class="ml-1 nowrap"
                      :class="{
                        'vp-mt-13 vp-mb-10':
                          compliance.form_metadata &&
                          compliance.form_metadata.status,
                      }"
                    >
                      <template
                        v-if="
                          compliance.form_metadata.status == 'success' &&
                          compliance.form_metadata.isDirty
                        "
                      >
                        {{ $tc("signInOut.complianceStatus", 0) }}</template
                      >
                      <template
                        v-else-if="
                          compliance.form_metadata.status == 'justified' &&
                          compliance.form_metadata.isDirty
                        "
                      >
                        {{ $t("signInOut.justified") }}</template
                      >
                      <template
                        v-else-if="compliance.form_metadata.status == 'failed'"
                        >{{ $tc("signInOut.complianceStatus", 1) }}</template
                      >
                    </p>

                    <button
                      :disabled="massActionIsStarted"
                      @click="actionModalHandler(compliance, item.id)"
                      :class="{
                        'vp-mb-10':
                          compliance.form_metadata &&
                          compliance.form_metadata.status,
                      }"
                      class="fillin-btn"
                    >
                      {{
                        compliance.form_metadata.isDirty
                          ? $t("common.update")
                          : $t("signInOut.fillIn")
                      }}
                    </button></template
                  >

                  <template v-else
                    ><p class="default-text-style">
                      {{ $tc("signInOut.complianceStatus", 2) }}
                    </p></template
                  >
                </template>
              </md-table-cell>
              <!-- end:: Compliances -->

              <!-- start:: Document -->
              <md-table-cell
                v-if="item.documents && item.documents.length"
                :md-label="
                  item.documents[0].isOptional
                    ? `${item.documents[0].complianceDocument[0].name} ${$t(
                        'common.optionalWithBrackets'
                      )}`
                    : `${item.documents[0].complianceDocument[0].name}`
                "
              >
                <template v-if="!item.signedOut"
                  ><p
                    class="d-flex flex-column justify-content-center cell-min-height"
                  >
                    -
                  </p>
                </template>
                <template v-else>
                  <p
                    v-if="
                      item.documents[0] &&
                      !item.documents[0].complianceDocument[0].isRequired &&
                      !item.documents[0].documentModel.isFilledInCopmpliance
                    "
                    class="default-text-style"
                  >
                    {{ $tc("signInOut.complianceStatus", 3) }}
                  </p>
                  <template v-else>
                    <p
                      :class="{
                        'ml-1 vp-mt-13 vp-mb-10':
                          item.documents[0] &&
                          item.documents[0].documentModel &&
                          item.documents[0].documentModel.status,
                      }"
                    >
                      <template
                        v-if="
                          item.documents[0].documentModel.status ==
                            'completed' ||
                          (item.documents[0].documentModel.status ==
                            'success' &&
                            item.documents[0].isOptional)
                        "
                        >{{ $tc("signInOut.status", 2) }}</template
                      >
                      <template
                        v-else-if="
                          (item.documents[0].documentModel.status ==
                            'success' &&
                            item.documents[0].documentModel.isDirty) ||
                          (item.documents[0].documentModel.status ==
                            'success' &&
                            item.documents[0].documentModel
                              .isFilledInCopmpliance)
                        "
                      >
                        {{ $tc("signInOut.complianceStatus", 1) }}</template
                      >
                      <template
                        v-else-if="
                          item.documents[0].documentModel.status == 'failed' &&
                          item.documents[0].documentModel.isFilledInCopmpliance
                        "
                        >{{ $tc("signInOut.complianceStatus", 2) }}</template
                      >
                    </p>
                    <button
                      :disabled="massActionIsStarted"
                      @click="actionModalHandler(item.documents[0])"
                      :class="{
                        'vp-mb-10':
                          item.checksModel?.temperature || item.checksModel?.mask,
                      }"
                      class="fillin-btn"
                    >
                      {{
                        item.documents[0].documentModel.isDirty
                          ? $t("common.update")
                          : $t("signInOut.fillIn")
                      }}
                    </button>
                  </template>
                </template>
              </md-table-cell>
              <!-- end:: Document -->

              <md-table-cell
                :class="{'print-badge-cell': item.printBadge != '-'}"
                :md-label="$t('journeyBuilder.flow.printBadge')"
                v-if="showPrintBadgeColumn"
              >
                <span v-if="item.printBadge == '-'">-</span>
                <b-form-checkbox
                v-else
                  class="switch-gray custom-switch-input"
                  switch
                  size="lg"
                  :disabled="massActionIsStarted"
                  v-model="item.printBadge"
                  @change="printBadgeChanged($event)"
                ></b-form-checkbox>
              </md-table-cell>

              <!-- start:: Status -->
              <md-table-cell :md-label="$t('common.status')">
                <p
                  class="d-flex flex-column justify-content-center cell-min-height"
                >
                  <template v-if="showRowStatus">
                    <span
                      :class="{
                        'status-completed': item.status == 'Completed',
                        'status-in-progress': item.status == 'In progress',
                        'status-pending': item.status == 'Pending',
                      }"
                    >
                      {{
                        item.status == "Completed"
                          ? $tc("signInOut.status", 2)
                          : item.status == "In progress"
                          ? $tc("signInOut.status", 1)
                          : $tc("signInOut.status", 0)
                      }}
                    </span>
                  </template>
                  <template v-else>-</template>
                </p>
              </md-table-cell>
              <!-- end:: Status -->
            </template>
            <!----------------------------------- end:: Single action -------------------------------------->
          </md-table-row>

          <!-- end::table rows -->
        </md-table>
        <!-- end::table -->
      </div>

      <!----------------------------------- start:: Modals -------------------------------------->
      <!-- start:: Checks modal -->
      <b-modal id="checks" size="md" scrollable hide-header hide-footer>
        <Checks
          @checks="checksFillinHandler"
          @allChecksAction="allChecksActionHandler"
          :modalHeaderTitle="checksColumnName"
        />
      </b-modal>
      <!-- end:: Checks modal -->

      <!-- start:: Notes modal -->
      <b-modal id="adminNotes" size="md" scrollable hide-header hide-footer>
        <Notes
          @notesSubmit="notesSubmit"
          @massActionNotesSubmit="massActionNotesSubmit"
        />
      </b-modal>
      <!-- end:: Notes modal -->

      <!-- start:: Single compliance modal -->
      <b-modal id="compliance" size="md" scrollable hide-header hide-footer>
        <Compliance
          @complainceSubmit="complainceSubmit"
          @massActionComplianceSubmit="massActionComplianceSubmit"
        />
      </b-modal>
      <!-- end:: Single compliance modal -->

      <!-- start:: Document modal -->
      <b-modal id="document" size="md" scrollable hide-header hide-footer>
        <Document
          @documentSubmit="documentSubmit"
          @massActionDocumentSubmit="massActionDocumentSubmit"
        />
      </b-modal>
      <!-- end:: Document modal -->

      <!-- start:: Host modal -->
      <b-modal id="host" size="md" scrollable hide-header hide-footer>
        <Host
          @hostSubmit="hostSubmit"
          @massActionHostSubmt="massActionHostSubmt"
        />
      </b-modal>
      <!-- end:: Checks modal -->

      <!-- start::Redirect modal -->
      <b-modal
        id="redirectModal"
        size="md"
        scrollable
        hide-header
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <ConfirmModal />
      </b-modal>
      <!-- end::Redirect modal -->

      <!-- start::Render fields modal-->
      <b-modal id="sectionModal" size="md" scrollable hide-header hide-footer>
        <Section @updateCustomField="updateCustomField" />
      </b-modal>
      <!-- end::Render fields modal -->

      <!-- start::Print Badge modal-->
      <b-modal id="printBadgeModal" size="md" scrollable hide-header hide-footer>
        <PrintBadgeModal :fromMassAction="true" :selectedUsers="selectedUsersForPrint" @applyPrint="applyPrint" />
      </b-modal>
      <!-- end::Print Badge modal -->
      <!----------------------------------- end:: Modals -------------------------------------->
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Checks from "./modals/Checks.vue";
import Compliance from "./modals/Compliance.vue";
import Notes from "./modals/Notes.vue";
import Document from "./modals/Document.vue";
import Host from "./modals/Host.vue";
import ConfirmModal from "./modals/ConfirmModal.vue";
import Section from "./modals/Section.vue";
import PrintBadgeModal from "./modals/printBadgeModal.vue";
import PrintBadgeForm from "./printBadgeForm.vue";
import moment from "moment";
import { cloneDeep } from "lodash";
import { requiredIf } from "vuelidate/lib/validators";
import { getCustomFieldsPayload } from "@/utils/mixins/customFieldValueParser";

export default {
  title: "Mass action",
  name: "massaction",
  components: {
    Checks,
    Compliance,
    Notes,
    Document,
    Host,
    ConfirmModal,
    Section,
    PrintBadgeModal,
    PrintBadgeForm,
  },
  data() {
    return {
      selectedUsersForPrint: [],
      usersForPrint: [],
      allUsersBeforeMountData: [],
      resultSet: [],
      enableNextMultipleUserTypeBtn: false,
      isMultipleUserType: false,
      multipleUsersData: {},
      displayHostMasActionAddButton: false,
      showRowStatus: false,
      disableMassActionButton: false,
      massActionIsStarted: false,
      isLoaded: false,
      tableData: [],
      showNoteColumnTemp: false,
      showChecksColumnTemp: false,
      showHostColumnTemp: false,
      showPrintBadgeColumn: false,
      checksColumnName: "",
      isDocumentOptional: false,
      kioskName: "",
      kiosk_id: null,
      maskOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      site_id: null,
    };
  },

  validations() {
    if (Object.keys(this.tableData)?.length > 0 && this.isLoaded) {
      return {
        tableData: {
          $each: {
            documents: {
              $each: {
                documentValidation: (document) => {
                  if (
                    document &&
                    (document?.documentModel?.isFilledInCopmpliance ||
                      (document?.complianceDocument[0]?.isRequired &&
                        !document?.isOptional)) &&
                    document?.documentModel?.status != "success" &&
                    document?.documentModel?.status != "completed"
                  ) {
                    return false;
                  }
                  return true;
                },
              },
            },
            hostModel: {
              selectedHost: {
                hostValidation: (host, model) => {
                  if (model && !host?.id && model?.no_host_selected == false)
                    return false;
                  return true;
                },
              },
            },
            errors: {
              invalidIfExistWithoutNotes: (value, nestedModel) => {
                if (!value?.length) return true;
                if (
                  value?.length &&
                  nestedModel.adminNotes?.notes?.length >= 20
                )
                  return true;
                return false;
              },
            },
            checksModel: {
              temperature: {
                currentValue: {
                  mustNotBeHigh: (_, nestedModel) => {
                    //If temperature is not added to checks return valid
                    if (!nestedModel) return true;
                    const unitType = nestedModel.unitType;
                    let temperature = nestedModel.currentValue;
                    if (unitType == "f") {
                      temperature = ((nestedModel.currentValue - 32) * 5) / 9;
                    }
                    return temperature <= nestedModel.temperature_threshold;
                  },
                  mustNotBeLow: (_, nestedModel) => {
                    //If temperature is not added to checks return valid
                    if (!nestedModel) return true;
                    const unitType = nestedModel.unitType;
                    let temperature = nestedModel.currentValue;
                    if (unitType == "f") {
                      temperature = ((nestedModel.currentValue - 32) * 5) / 9;
                    }
                    return temperature >= 20;
                  },
                },
              },
              mask: {
                currentValue: {
                  mustBePositive: function (maskValue, model) {
                    //If mask is not added to checks return valid
                    if (!model) return true;
                    return maskValue;
                  },
                },
              },
            },
            complinaces: {
              $each: {
                form_metadata: {
                  complianceValidation: (form_metadata, complianceModel) => {
                    if (
                      (form_metadata.isExpected ||
                        complianceModel.isRequired) &&
                      form_metadata.status != "success" &&
                      form_metadata.status != "completed" &&
                      form_metadata.status != "justified"
                    )
                      return false;
                    return true;
                  },
                },
              },
            },
            lateSignInReason: {
              required: requiredIf(function (userData) {
                return !userData.all && userData.showLateSignInReason;
              }),
            },
            earlySignOutReason: {
              required: requiredIf(function (userData) {
                return !userData.all && userData.showEarlySignOutReason;
              }),
            },
            sections: {
              $each: {
                custom_fields: {
                  $each: {
                    value: {
                      required: requiredIf(function (field) {
                        return field.isActive && field.is_mandatory;
                      }),
                    },
                  },
                },
              },
            },
          },
        },
      };
    }
  },
  computed: {
    ...mapGetters("dailyLogbook", [
      "getMultipleUsersData",
      "getCheckinsUsersInLoaderStatus",
    ]),
    checkIfInvalid() {
      let isChecksInvalid = false,
        checksModelIsNotTouched = false,
        isCompliancesInvalid = false,
        isHostInvalid = false,
        isDocumentInvalid = false,
        lateSignInReasonInvalid = false,
        earlySignOutReasonInvalid = false,
        sectionsInvalid = false;

      Object.keys(this.$v.tableData.$each.$iter)?.forEach((row) => {
        if (row > 0) {
          //Check if checksModel is updated (temperature and mask) if exists
          if (
            this.tableData[row].signedOut &&
            this.tableData[row]?.checksModel &&
            !this.$v.tableData.$each.$iter[row]?.checksModel?.$model?.isDirty
          )
            checksModelIsNotTouched = true;

          //Notes + Errors
          if (this.$v.tableData.$each.$iter[row].errors?.$invalid)
            isChecksInvalid = true;

          //Host
          if (
            this.tableData[row].signedOut &&
            this.$v.tableData.$each.$iter[row].hostModel?.selectedHost?.$invalid
          )
            isHostInvalid = true;

          //Compliances
          Object.keys(
            this.$v.tableData.$each.$iter[row]?.complinaces?.$each?.$iter
          )?.forEach((complianceIndex) => {
            if (
              this.tableData[row].signedOut &&
              this.$v.tableData.$each.$iter[row]?.complinaces?.$each?.$iter[
                complianceIndex
              ].form_metadata.$invalid
            )
              isCompliancesInvalid = true;
              
          });

          //Document
          if (
            this.tableData[row].signedOut &&
            this.$v.tableData.$each.$iter[row]?.documents?.$each.$iter[0]
              ?.$invalid
          )
            isDocumentInvalid = true;

          //Early sign out reason
          if (this.$v.tableData.$each.$iter[row]?.earlySignOutReason.$invalid)
            earlySignOutReasonInvalid = true;

          //Late sign in reason
          if (this.$v.tableData.$each.$iter[row]?.lateSignInReason.$invalid)
            lateSignInReasonInvalid = true;

          //Section
          if (this.$v.tableData.$each.$iter[row]?.sections.$invalid)
            sectionsInvalid = true;
        }
      });
      return (
        isChecksInvalid ||
        checksModelIsNotTouched ||
        isCompliancesInvalid ||
        isHostInvalid ||
        isDocumentInvalid ||
        earlySignOutReasonInvalid ||
        lateSignInReasonInvalid ||
        sectionsInvalid
      );
    },
  },
  watch: {
    tableData: {
      handler() {
        let isChecksInvalid = false,
          checksModelIsNotTouched = false,
          isCompliancesInvalid = false,
          isHostInvalid = false,
          isDocumentInvalid = false;

        Object.keys(this.$v.tableData.$each.$iter)?.forEach((row) => {
          if (row > 0) {
            //Check if checksModel is updated (temperature and mask) if exists
            if (
              this.tableData[row].signedOut &&
              this.tableData[row]?.checksModel &&
              !this.$v.tableData.$each.$iter[row]?.checksModel?.$model?.isDirty
            )
              checksModelIsNotTouched = true;

            //Notes + Errors
            if (this.$v.tableData.$each.$iter[row].errors?.$invalid)
              isChecksInvalid = true;

            //Host
            if (
              this.tableData[row].signedOut &&
              this.$v.tableData.$each.$iter[row].hostModel?.selectedHost
                ?.$invalid
            )
              isHostInvalid = true;

            //Compliances
            Object.keys(
              this.$v.tableData.$each.$iter[row]?.complinaces?.$each?.$iter
            )?.forEach((complianceIndex) => {
              if (
                this.tableData[row].signedOut &&
                this.$v.tableData.$each.$iter[row]?.complinaces?.$each?.$iter[
                  complianceIndex
                ].form_metadata.$invalid
              )
                isCompliancesInvalid = true;
            });

            //Document
            if (
              this.tableData[row].signedOut &&
              this.$v.tableData.$each.$iter[row]?.documents?.$each.$iter[0]
                ?.$invalid
            )
              isDocumentInvalid = true;
          }
        });
        this.disableMassActionButton =
          isChecksInvalid ||
          checksModelIsNotTouched ||
          isCompliancesInvalid ||
          isHostInvalid ||
          isDocumentInvalid;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("dailyLogbook", [
      "clearMultipleUsersData",
      "massActionCheckInUsers",
      "fetchMultipleUsersData",
    ]),
    ...mapActions("modal", ["setData"]),
    printBadgeForAllChanged(data) {
      this.tableData.forEach(user => {
        if (user.printBadge != "-") {
          user.printBadge = data;
          this.showPrintBadgeColumn = false;
          this.showPrintBadgeColumn = true; // for re-rendering values in table
        }
      });
    },
    printBadgeChanged(data) {
      if (!data) {
        this.tableData[0].printBadge = false;
        this.showPrintBadgeColumn = false;
        this.showPrintBadgeColumn = true; // for re-rendering values in table
      }
    },
    updateCustomField(fieldData) {
      // Check if the row exists
      const rowIndex = this.tableData?.findIndex(
        (user) => user.id === fieldData.userId
      );
      if (rowIndex === -1) return; // Early exit if row not found

      // Find the section index within the row
      const sectionIndex = this.tableData[rowIndex].sections.findIndex(
        (section) => section.id === fieldData.id
      );
      if (sectionIndex === -1) return; // Early exit if section not found

      // Update the field with new data
      this.tableData[rowIndex].sections[sectionIndex] = fieldData;

      //Due to vue2 deep reactivity (only on first level) ,reset tableData object to update data
      this.tableData = cloneDeep(this.tableData);
    },
    actionModalHandler(data, userId = null) {
      if (userId) {
        Object.assign(data, { userId });
      }
      this.setData(data);
      switch (data.type) {
        case "questionnaire":
          this.$bvModal.show("compliance");
          break;
        case "agreement":
          this.$bvModal.show("compliance");
          break;
        case "document":
          this.$bvModal.show("document");
          break;
        case "checks":
          this.$bvModal.show("checks");
          break;
        case "host":
          this.$bvModal.show("host");
          break;
        case 0:
        case 1:
          this.$bvModal.show("sectionModal");
          break;
        default:
          return;
      }
    },
    hostSubmit(hostModel) {
      this.tableData.forEach((userData, indx) => {
        if (!userData.all && userData.id == hostModel.user_id) {
          this.tableData[indx].hostModel = hostModel;
        }
      });
    },
    massActionHostSubmt(hostModel) {
      this.tableData.forEach((userData, indx) => {
        if (!userData.all && userData.signedOut) {
          const newObject = Object.assign(
            {},
            {
              ...hostModel,
              host_user_id: this.tableData[indx].host_user_id,
              host_user_ids: null,
              user_id: this.tableData[indx].id,
            }
          );
          this.tableData[indx].hostModel = newObject;
        }
      });
    },
    massActionDocumentSubmit(documentModel) {
      this.tableData.forEach((userData, indx) => {
        if (!userData.all && userData.signedOut) {
          if (
            (userData.documents[0]?.complianceDocument[0]?.isRequired ==
              false &&
              userData.documents[0]?.documentModel?.isFilledInCopmpliance ==
                true) ||
            userData.documents[0]?.complianceDocument[0]?.isRequired == true ||
            userData.documents[0]?.documentModel?.isFilledInCopmpliance == true
          ) {
            const newDocumentModelObject = Object.assign(
              {},
              {
                ...documentModel,
                actionByRole:
                  this.tableData[indx].documents[0].documentModel
                    ?.actionByRole ?? null,
                actionByName:
                  this.tableData[indx].documents[0]?.documentModel
                    ?.actionByName ?? null,
                updatedAt:
                  this.tableData[indx]?.documents[0]?.documentModel?.updatedAt,
                isFilledInCopmpliance:
                  this.tableData[indx]?.documents[0]?.documentModel
                    ?.isFilledInCopmpliance,

                user_id: this.tableData[indx].id,
              }
            );
            this.tableData[indx].documents[0].documentModel =
              newDocumentModelObject;
          }
        }
      });
    },
    documentSubmit(documentModel) {
      this.tableData.forEach((userData, indx) => {
        if (!userData.all) {
          if (documentModel.user_id == userData.id) {
            this.tableData[indx].documents[0].documentModel = documentModel;
            this.tableData[indx].documents[0].documentModel.selectedDocument =
              documentModel.selectedDocument; //force update
            this.tableData[
              indx
            ].documents[0].documentModel.isFilledInCopmpliance = false;
          }
        }
      });
    },
    massActionComplianceSubmit(form_metadata, compliance_id) {
      this.tableData.forEach((userData, indx) => {
        if (!userData.all && userData.signedOut) {
          userData.complinaces?.forEach((compliance, complianceIndex) => {
            if (compliance_id == compliance.id) {
              //If compliance is previously filled in ,keep state of (action by ,date ...)
              if (
                compliance.isRequired == false &&
                compliance.form_metadata?.isExpected == true
              ) {
                Object.assign(
                  this.tableData[indx].complinaces[complianceIndex]
                    .form_metadata,
                  { ...form_metadata }
                );
              } else if (
                compliance.isRequired ||
                compliance.form_metadata?.isExpected
              ) {
                this.tableData[indx].complinaces[
                  complianceIndex
                ].form_metadata = form_metadata;
              }
            }
          });
        }
      });
    },
    complainceSubmit(form_metadata, user_id, compliance_id) {
      this.tableData.forEach((userData, indx) => {
        if (!userData.all && user_id == userData.id) {
          userData.complinaces?.forEach((compliance, complianceIndex) => {
            if (compliance_id == compliance.id) {
              this.tableData[indx].complinaces[complianceIndex].form_metadata =
                form_metadata;
            }
          });
        }
      });
    },
    massActionNotesSubmit(notesData) {
      this.tableData.forEach((userData, indx) => {
        if (!userData.all) {
          const newObject = Object.assign(
            {},
            {
              ...notesData,
              user_id: this.tableData[indx].id,
            }
          );
          this.tableData[indx].adminNotes = newObject;
        }
      });
    },
    adminNotesModalHandler(data) {
      this.setData(data);
      this.$bvModal.show("adminNotes");
    },
    checkIfAtleastOneUserHasError() {
      let hasError = false;
      this.tableData?.forEach((userData) => {
        if (userData?.errors && userData?.errors?.length) hasError = true;
      });
      return hasError;
    },
    notesSubmit(notes) {
      this.tableData.forEach((userData, indx) => {
        if (!userData.all && userData.id == notes.user_id) {
          this.tableData[indx].adminNotes = notes;
        }
      });
    },
    allChecksActionHandler(checksValue) {
      //set errors
      this.tableData.forEach((userData, indx) => {
        if (!userData.all && userData.signedOut) {
          const newObject = Object.assign(
            {},
            {
              ...checksValue,
              user_id: this.tableData[indx].id,
            }
          );

          this.tableData[indx].checksModel = newObject;

          let errorsSet = new Set();
          // "No mask" validation (Add to 'errors')
          if (
            this.$v.tableData?.$each?.$iter[indx]?.checksModel?.mask
              ?.currentValue?.$invalid
          ) {
            errorsSet.add(this.$t('common.noMask'));
          } else if (
            !this.$v.tableData?.$each?.$iter[indx]?.checksModel?.mask
              ?.currentValue?.$invalid
          ) {
            //Remove mask error if admin selected 'has mask'.
            errorsSet.delete(this.$t('common.noMask'));
          }

          // 'High temperature'/'Low temperature' validation (Add to 'errors')
          if (
            !this.$v.tableData?.$each?.$iter[indx]?.checksModel?.temperature
              ?.currentValue?.mustNotBeLow
          ) {
            errorsSet.delete(this.$t('common.highTemperature'));
            errorsSet.add(this.$t('common.lowTemperature'));
          } else if (
            !this.$v.tableData?.$each?.$iter[indx]?.checksModel?.temperature
              ?.currentValue?.mustNotBeHigh
          ) {
            errorsSet.delete(this.$t('common.lowTemperature'));
            errorsSet.add(this.$t('common.highTemperature'));
          } else if (
            this.$v.tableData?.$each?.$iter[indx]?.checksModel?.temperature
              ?.currentValue?.mustNotBeHigh &&
            this.$v.tableData?.$each?.$iter[indx]?.checksModel?.temperature
              ?.currentValue?.mustNotBeLow
          ) {
            errorsSet.delete(this.$t('common.highTemperature'));
            errorsSet.delete(this.$t('common.lowTemperature'));
          }
          this.tableData[indx].errors = Array.from(errorsSet).concat(
            this.multipleUsersData.users[indx].errors
          );
        }
      });
    },
    checksFillinHandler(checksValue) {
      this.tableData.forEach((userData, indx) => {
        if (!userData.all && userData.id == checksValue.user_id) {
          this.tableData[indx].checksModel = checksValue;

          let errorsSet = new Set();
          // "No mask" validation (Add to 'errors')
          if (
            this.$v.tableData?.$each?.$iter[indx]?.checksModel?.mask
              ?.currentValue?.$invalid
          ) {
            errorsSet.add(this.$t('common.noMask'));
          } else if (
            !this.$v.tableData?.$each?.$iter[indx]?.checksModel?.mask
              ?.currentValue?.$invalid
          ) {
            //Remove mask error if admin selected 'has mask'.
            errorsSet.delete(this.$t('common.noMask'));
          }

          // 'High temperature'/'Low temperature' validation (Add to 'errors')
          if (
            !this.$v.tableData?.$each?.$iter[indx]?.checksModel?.temperature
              ?.currentValue?.mustNotBeLow
          ) {
            errorsSet.delete(this.$t('common.highTemperature'));
            errorsSet.add(this.$t('common.lowTemperature'));
          } else if (
            !this.$v.tableData?.$each?.$iter[indx]?.checksModel?.temperature
              ?.currentValue?.mustNotBeHigh
          ) {
            errorsSet.delete(this.$t('common.lowTemperature'));
            errorsSet.add(this.$t('common.highTemperature'));
          } else if (
            this.$v.tableData?.$each?.$iter[indx]?.checksModel?.temperature
              ?.currentValue?.mustNotBeHigh &&
            this.$v.tableData?.$each?.$iter[indx]?.checksModel?.temperature
              ?.currentValue?.mustNotBeLow
          ) {
            errorsSet.delete(this.$t('common.highTemperature'));
            errorsSet.delete(this.$t('common.lowTemperature'));
          }
          this.tableData[indx].errors = Array.from(errorsSet).concat(
            this.multipleUsersData.users[indx].errors
          );
        }
      });
    },
    lateSignInMassAction(selected) {
      this.tableData.forEach((user, indx) => {
        if (user.showLateSignInReason && !user.all) {
          this.$v.tableData.$each.$iter[indx].lateSignInReason.$model =
            selected;
        }
      });
    },
    earlySignOutMassAction(selected) {
      this.tableData.forEach((user, indx) => {
        if (user.showEarlySignOutReason && !user.all) {
          this.$v.tableData.$each.$iter[indx].earlySignOutReason.$model =
            selected;
        }
      });
    },
    checkMassActionLateSignInReason() {
      this.$v.tableData.$each.$iter[0].lateSignInReason.$model = null;
    },
    checkMassActionEarlySignOutReason() {
      this.$v.tableData.$each.$iter[0].earlySignOutReason.$model = null;
    },
    onMultiselectOpen(options) {
      let padding = options?.length > 3 ? 3 : options.length;
      padding *= 45;

      setTimeout(() => {
        const lastMultiselectActive = document.querySelector(
          "tbody>tr:nth-last-child(1) .multiselect--active"
        );
        const lastMultiselectActive_2 = document.querySelector(
          "tbody>tr:nth-last-child(2) .multiselect--active"
        );
        const lastMultiselectActive_3 = document.querySelector(
          "tbody>tr:nth-last-child(3) .multiselect--active"
        );
        const table = document.querySelector(".md-table-content");
        if (lastMultiselectActive)
          // 135
          table.classList.add(`vp-pb-${padding}`);
        //(135-90-45)
        else if (lastMultiselectActive_2)
          // 50
          table.classList.add(`vp-pb-${padding - 50}`);
        //(85,40)
        else if (lastMultiselectActive_3)
          // 20
          table.classList.add(`vp-pb-${padding - 90}`); //(45)
      }, 1);
    },
    onMultiselectClose() {
      const table = document.querySelector(".md-table-content");
      table.classList.remove(
        "vp-pb-135",
        "vp-pb-90",
        "vp-pb-85",
        "vp-pb-45",
        "vp-pb-40",
        "vp-pb-20"
      );
    },
    applyPrint(data) {
      this.kiosk_id = null;
      console.log("applyPrint", data);
      if (data.selectedPrint == "online") {
        this.kiosk_id = data.selectedKiosk;
        this.kioskName = data.kioskName;
        this.submitHandler();
      } else {
        this.submitHandler();
      }
    },
    async massActionSignInHandler() {
      let showPrintBadgeModal = false;
      this.tableData.forEach((userData) => {
        if (!userData.all && userData.printBadge == true) showPrintBadgeModal = true;
      });
      if (showPrintBadgeModal) {
        this.selectedUsersForPrint = this.tableData.filter((userData) => !userData.all && userData.printBadge == true);
        this.$bvModal.show("printBadgeModal");
      }
      else {
        this.submitHandler();
      }
    },

    async submitHandler() {
      this.massActionIsStarted = true;
      this.showRowStatus = true;
      this.tableData.forEach((userData) => {
        if (!userData.all) userData.status = "Pending";
      });

      const { area, user_type } = this.multipleUsersData;
      for (const userData of this.tableData) {
        // let userIndex = index - 1;

        let formData = new FormData();
        formData.append("area_id", area.id);
        formData.append("user_type_id", user_type.id);
        userData.status = "In progress";
        let compliances = [];
        if (!userData.all) {
          if (this.kiosk_id && userData.printBadge == true) formData.append("kiosk_id", this.kiosk_id);
          if (userData.signedOut)
            formData.append(
              "scan[reasonPresentName]",
              userData.lateSignInReason?.isPresented
                ? userData.lateSignInReason.name
                : ""
            );
          else if (!userData.signedOut)
            formData.append(
              "scan[reasonPresentName]",
              userData.earlySignOutReason?.isPresented
                ? userData.earlySignOutReason.name
                : ""
            );
          formData.append(
            "scan[attendanceCodeId]",
            userData.lateSignInReason?.attendance_code ||
              userData.earlySignOutReason?.attendance_code ||
              userData.attendanceCodeIfNoReasons ||
              ""
          );

          formData.append(
            "scan[reasonId]",
            userData.lateSignInReason?.reason_id ||
              userData.earlySignOutReason?.reason_id ||
              ""
          );
          formData.append(`user_id`, userData.id ?? "");
          if (userData.checksModel?.temperature) {
            formData.append(
              `temperature`,
              userData.checksModel?.temperature?.currentValue ?? ""
            );
            formData.append(
              `temperature_type`,
              userData.checksModel?.temperature?.unitType ?? ""
            );
          } else {
            formData.append("temperature", "0");
            formData.append("temperature_type", "c");
          }

          if (userData.sections && !!userData.sections.length) {
            //Filter only sections that are binded to the user.
            let customFields = getCustomFieldsPayload(
              userData.sections.filter((section) => !section.readOnly)
            );
            if (customFields?.length)
              formData.append("custom_fields", JSON.stringify(customFields));
          }

          if (userData.checksModel?.mask)
            formData.append(
              `has_mask`,
              userData.checksModel?.mask?.currentValue === true ? 1 : 0
            );
          else formData.append("has_mask", "-1");

          formData.append(`notes`, userData.adminNotes?.notes ?? "");
          if (this.showHostColumnTemp) {
            formData.append(
              `host`,
              userData.hostModel?.no_host_selected
                ? ""
                : userData?.hostModel?.selectedHost.id
            );
          } else {
            formData.append(`host`, "");
          }

          if (userData.complinaces && userData.complinaces.length > 0) {
            userData.complinaces.forEach((compliance) => {
              //Add compliance only if user is signed out and (compliance is required or compliance is previously filled in (compliance fillin))
              if (
                userData.signedOut == true &&
                (compliance.isRequired == true ||
                  compliance.form_metadata?.isExpected == true)
              ) {
                let answer = [];
                compliance.form_metadata?.questions?.forEach((question) => {
                  const answerObject = {
                    actionBy: "Admin",
                    body: question.body,
                    complianceId: compliance.id,
                    notes: compliance.form_metadata?.notes,
                    type: compliance.type,
                    answer: {
                      ...question.finalAnswers,
                      answerImage: "     ",
                    },
                  };
                  answer.push(answerObject);
                });
                compliances.push({
                  complianceId: compliance.id,
                  name: compliance.name,
                  answer,
                });
              }
            });
          }

          compliances?.length
            ? formData.append(`compliances`, JSON.stringify(compliances))
            : formData.append(`compliances`, []);

          if (
            !userData.documents ||
            userData?.documents?.length == 0 ||
            (userData?.documents[0]?.isOptional &&
              userData?.documents[0]?.documentModel?.isDirty === false)
          ) {
            formData.append("document", []);
          } else if (userData.documents && userData.documents.length) {
            const vaccine_pcr = userData.documents[0]?.documentModel;
            const complianceDocument =
              userData.documents[0]?.complianceDocument[0];

            const vaccineData = {
              certificateModel: {
                extraData: {},
                dateOfBirth: "",
                kid: "",
                person: {
                  familyName: userData.last_name,
                  givenName: userData.first_name,
                  standardisedFamilyName: userData.last_name,
                  standardisedGivenName: userData.fist_name,
                },
                signature: "",
                vaccinations: [
                  {
                    certificateIdentifier: "",
                    certificateIssuer: "",
                    countryOfVaccination: "",
                    dateOfVaccination: vaccine_pcr?.vaccine_date_taken
                      ? vaccine_pcr.vaccine_date_taken
                      : "",
                    disease: "COVID-19",
                    doseNumber: "",
                    manufacturer: "",
                    medicinalProduct: "",
                    totalSeriesOfDoses: "",
                    batchNumber: vaccine_pcr?.batch_number || "",
                    vaccine: vaccine_pcr?.vaccine_name || "",
                  },
                ],
              },
              generalVerificationResult: "",
              greenCertificatData: {
                expirationTime: vaccine_pcr?.vaccine_expiry_date,
                issuedAt: "",
                issuingCountry: "",
              },
              type: "",
              notes: vaccine_pcr?.compliance_notes || "",
              protocol: vaccine_pcr?.vaccine_protocol || "",
            };

            const pcrData = {
              certificateModel: {
                dateOfBirth: "",
                kid: "",
                person: {
                  familyName: userData.last_name,
                  givenName: userData.first_name,
                  standardisedFamilyName: userData.last_name,
                  standardisedGivenName: userData.first_name,
                },
                signature: "",
                tests: [
                  {
                    disease: "",
                    typeOfTest: "",
                    testName: "",
                    testNameAndManufacturer: null,
                    dateTimeOfCollection: "",
                    dateTimeOfTestResult: vaccine_pcr?.pcr_date_taken
                      ? moment(vaccine_pcr.pcr_date_taken, "DD/MM/YYYY").format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      : "",
                    testResult: vaccine_pcr?.pcr_result?.value,
                    testResultCode: "260415000",
                    testingCentre: "",
                    countryOfVaccination: "",
                    certificateIssuer: "",
                    certificateIdentifier: "",
                    countryCode: "",
                  },
                ],
              },
              generalVerificationResult: "",
              greenCertificatData: {
                expirationTime: "",
                issuedAt: "",
                issuingCountry: "",
              },
              type: "INTERNATIONAL",
              notes: vaccine_pcr?.compliance_notes || "",
            };

            const documents = {
              complianceId: complianceDocument?.id ?? null,
              document_id: vaccine_pcr?.selectedDocument
                ? vaccine_pcr?.selectedDocument?.id
                : "",
              notes: vaccine_pcr?.compliance_notes || "",
              data: {
                entity_id: complianceDocument?.entity_id || "",
                metadata:
                  vaccine_pcr?.vaccine_pcr == "vaccine" ? vaccineData : pcrData,
                user_id: userData.id,
                expiry_date: vaccine_pcr?.vaccine_expiry_date,
                start_date:
                  vaccine_pcr.vaccine_pcr == "vaccine"
                    ? null
                    : vaccine_pcr?.pcr_date_taken,
                notes: vaccine_pcr?.document_notes || "",
                type: this.handleCovidType(vaccine_pcr),
                fileAttach: vaccine_pcr?.vaccine_pcr_file,
              },
            };

            formData.append(
              "document[data][fileAttach]",
              documents?.data?.fileAttach ?? ""
            );
            formData.append(
              "document[document_id]",
              documents?.document_id ?? ""
            );
            formData.append(
              "document[complianceId]",
              complianceDocument.id ?? ""
            );
            formData.append(
              "document[data][entity_id]",
              documents?.data?.entity_id ?? ""
            );
            formData.append(
              "document[data][expiry_date]",
              documents?.data?.expiry_date
                ? moment(documents?.data?.expiry_date, "DD/MM/YYYY").format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : ""
            );
            formData.append(
              "document[data][metadata][fileAttach]",
              documents?.data?.fileAttach ?? ""
            );

            formData.append(
              "document[data][metadata][protocol]",
              vaccine_pcr?.vaccine_protocol ?? ""
            );
            formData.append(
              "document[data][metadata][certificateModel][extraData]",
              {}
            );
            formData.append(
              "document[data][metadata][certificateModel][dateOfBirth]",
              ""
            );
            formData.append(
              "document[data][metadata][certificateModel][kid]",
              ""
            );
            formData.append(
              "document[data][metadata][certificateModel][person][familyName]",
              userData.last_name ?? ""
            );
            formData.append(
              "document[data][metadata][certificateModel][person][givenName]",
              userData.first_name ?? ""
            );
            formData.append(
              "document[data][metadata][certificateModel][person][standardisedFamilyName]",
              userData.last_name ?? ""
            );
            formData.append(
              "document[data][metadata][certificateModel][person][standardisedGivenName]",
              userData.first_name ?? ""
            );
            formData.append(
              "document[data][metadata][certificateModel][signature]",
              ""
            );
            formData.append(
              "document[data][metadata][generalVerificationResult]",
              ""
            );
            formData.append(
              "document[data][metadata][greenCertificatData][expirationTime]",
              vaccine_pcr?.vaccine_expiry_date
                ? moment(vaccine_pcr?.vaccine_expiry_date, "DD/MM/YYYY").format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : ""
            );
            formData.append(
              "document[data][metadata][greenCertificatData][issuedAt]",
              ""
            );
            formData.append(
              "document[data][metadata][notes]",
              documents?.data?.notes ?? ""
            );
            formData.append(
              "document[data][metadata][type]",
              documents?.data?.type ?? ""
            );

            if (vaccine_pcr.vaccine_pcr == "vaccine") {
              for (
                let i = 0;
                i < vaccineData.certificateModel.vaccinations.length;
                i++
              ) {
                for (let key of Object.keys(
                  vaccineData.certificateModel.vaccinations[i]
                )) {
                  formData.append(
                    `document[data][metadata][certificateModel][vaccinations][${i}][${key}]`,
                    vaccineData.certificateModel.vaccinations[i][key] ?? ""
                  );
                }
              }
            } else if (
              vaccine_pcr.vaccine_pcr == "covid_pcr" ||
              vaccine_pcr.vaccine_pcr == "pcr"
            ) {
              for (let i = 0; i < pcrData.certificateModel.tests.length; i++) {
                for (let key of Object.keys(
                  pcrData.certificateModel.tests[i]
                )) {
                  formData.append(
                    `document[data][metadata][certificateModel][tests][${i}][${key}]`,
                    pcrData.certificateModel.tests[i][key] ?? ""
                  );
                }
              }
            }

            formData.append(
              "document[data][notes]",
              documents?.data?.notes ?? ""
            );
            formData.append(
              "document[notes]",
              vaccine_pcr?.compliance_notes ?? ""
            );
            formData.append(
              "document[data][start_date]",
              documents?.data?.start_date
                ? moment(documents.data.start_date, "DD/MM/YYYY").format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : ""
            );
            formData.append(
              "document[data][user_id]",
              documents?.data?.user_id ?? ""
            );
            formData.append(
              "document[data][type]",
              documents?.data?.type ?? ""
            );
          }

          let res = await this.massActionCheckInUsers(formData);

          userData.status = "Completed";
          if (res && res.data) {
            this.resultSet.add(res?.data[0]?.scan_data_type_id);
          }
        }
      }
      let result = Array.from(this.resultSet);

      this.setData({
        result,
        area_name: this.multipleUsersData.area.name,
        site_name: this.multipleUsersData.site_name,
        kioskName: this.kioskName ? this.kioskName : null
      });
      if (this.selectedUsersForPrint && this.selectedUsersForPrint.length && !this.kiosk_id) {
        this.selectedUsersForPrint.forEach(user => {
          if (user.printBadgeModel.showHost) {
            let fullName = "";
            if (user.hostModel?.selectedHost?.name?.userName) fullName = user.hostModel?.selectedHost?.name?.userName;
            else if (user.hostModel?.selectedHost?.name?.userName_with_userType) {
              const lastDashIndex = user.hostModel?.selectedHost?.name?.userName_with_userType.lastIndexOf(" - ");
              fullName = user.hostModel?.selectedHost?.name?.userName_with_userType.slice(0, lastDashIndex);
            }
            user.printBadgeModel.hostName = user.hostModel?.no_host_selected ? "" : fullName;
          }
          if (user.printBadgeModel.showTemperature) {
            user.printBadgeModel.temperature = user.checksModel?.temperature?.currentValue;
            user.printBadgeModel.unitType = user.checksModel?.temperature?.unitType;
          }
          if (user.printBadgeModel.showEarlySignOut) user.printBadgeModel.earlySignOutReason = user.earlySignOutReason?.name;
          if (user.printBadgeModel.showLateSignIn) user.printBadgeModel.lateSignInReason = user.lateSignInReason?.name;

          if (user.printBadgeModel.customFields.length) {
            user.printBadgeModel.customFields.map(field => {
              if (field.type == "ratingScale")  field.type = field.metadata[0].show_as;
            });
            if (user.sections && !!user.sections.length) {
              let customFields = getCustomFieldsPayload(
                user.sections.filter((section) => !section.readOnly)
              );
              user.printBadgeModel.customFields.map(field => {
                const customField = customFields.find(item => item.custom_field_id == field.id);
                if (customField && (customField.value || field.type == "toggleButton")) {
                  field.value = customField.value;
                }
              });
              user.printBadgeModel.customFields = user.printBadgeModel.customFields.filter(item => item.type == "toggleButton" || !!item.value);
            }
          }
        });
        this.usersForPrint = cloneDeep(this.selectedUsersForPrint);
        console.log('local print now', this.usersForPrint);
       setTimeout(()=>{
        this.printPage();
       }, 800);
      }

      if (!this.isMultipleUserType) this.$bvModal.show("redirectModal");
      else {
        this.enableNextMultipleUserTypeBtn = true;
        this.selectedUsersForPrint = [];
        this.kiosk_id = null;
        this.kioskName = "";
      }

      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }
    },

    printPage() {
      const printContent = document.getElementById("multi-print-area").innerHTML;
      const printWindow = window.open("", "", "width=800,height=600");

      const html = `
        <html>
          <head>
            <link href="https://fonts.googleapis.com/css2?family=Lato&display=swap" rel="stylesheet" onload="this.loaded=true">
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css" onload="this.loaded=true">
            <style>
              ${this.getPrintStyles()}
            </style>
            <scr` + `ipt>
              function waitForResources() {
                const links = document.querySelectorAll('link[rel="stylesheet"]');
                const allLoaded = Array.from(links).every(l => l.loaded);
                if (allLoaded) {
                  window.print();
                  window.close();
                } else {
                  setTimeout(waitForResources, 50);
                }
              }
            </scr` + `ipt>
          </head>
          <body onload="waitForResources()">
            ${printContent}
          </body>
        </html>
      `;

      printWindow.document.write(html);
      printWindow.document.close();
    },
    getPrintStyles() {
      return `
        @media print {
          body {
            zoom: 2; /* Scale content 2x (200%) */
          }
        }
        body {
          font-family: 'Lato';
        }
        .multi-print-page:not(:last-child) {
          page-break-after: always;
          break-after: page;
        }
        .multi-print-page {
          width: 255px;
          color: #000000;
          position: relative;
          padding: 5px 10px;
          padding-bottom: 0;
          text-align: start;
          min-height: 48vh;
        }
        .multi-print-text {
          font-size: 9px;
          font-weight: 700;
          position: relative;
          z-index: 1;
          line-height: 1.2;
        }
        .multi-watermark {
          position: absolute;
          font-size: 48px;
          color: rgba(0, 0, 0, 0.1);
          z-index: 0;
          pointer-events: none;
          white-space: nowrap;
        }
        .logo-watermark {
          top: 0;
          inset-inline-start: 20%;
        }
        .entity-watermark {
          top: 12%;
          inset-inline-start: 50%;
          transform: translate(-50%, -50%) rotate(-45deg);
        }
        
        .img-watermark {
          opacity: 15%;
          max-height: 121px;
          max-width: 78px;
          width: auto;
        }
        
        .qr-border {
          border: 3px solid black;
          padding: 3px;
          border-radius: 5px;
          max-width: 54px;
          width: 54px;
          height: 54px;
          position: relative;
          z-index: 1;
        }
        .qr-img {
          max-width: 53px;
          width: 53px;
          height: 53px;
        }
        .user-img {
          border-radius: 5px;
          width: 64px !important;
          height: 64px !important;
        }

        .sections {
          display: flex;
          flex-direction: column;
          gap: 7px;
        }

        .section1 {
            display: flex;
        }

        .section1.noPhotoNoQr {
          justify-content: center;
        }

        .section1.withPhotoQr, .section1.qrOnly {
            justify-content: space-between;
        }

        .section1.photoOnly {
            gap: 8px
        }

        .section1-text.noPhotoNoQr, .section1-text.withPhotoQr {
          text-align: center;
        }

        .section1-text,
        .section2 {
          display: flex;
          flex-direction: column;
          .multi-print-text-without-fields {
            margin-bottom: 8px;
          }
          .multi-print-text-with-fields {
            margin-bottom: 8px;
          }
        }

        .section1-text {
          height: 64px;
          justify-content: space-between;
        }

        .section2 {
          min-height: 60px;
          justify-content: center;
        }

        .section2.noPhotoNoQr {
            text-align: center;
        }

        .section3 {
            text-align: center;
            gap: 11px;
            display: flex;
            flex-direction: column;
        }

        .nowrap {
          white-space: nowrap;
        }

        .badge-separator {
          border-top: 0.75px solid #000000;
          margin-bottom: 8px;
        }

        .badge-section {
            height: 30px;
        }

        .badges {
            display: flex;
            flex-wrap: wrap;
            font-size: 9px;
            align-items: center;
          }

        .badge-block {
            display: flex;
            align-items: center;
            gap: 3px;
            flex: 0 0 50%;
        }

        .badge-icon {
          width: 15px;
          height: 15px;
          background: #000000;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2px;
        }
      `;
    },

    async nextUserTypeHandler() {
      this.$v.$reset();
      this.massActionIsStarted = false;

      //Remove first (fetched) element from allUsersBeforeMountData and concat all unfetched users (for next payload)
      let unFetchedUsers = [];

      this.allUsersBeforeMountData.splice(0, 1);

      this.allUsersBeforeMountData.forEach((userData) => {
        unFetchedUsers.push(...userData.users);
      });

      const payload = {
        area_id: this.multipleUsersData.area.id,
        users: unFetchedUsers,
      };
      await this.fetchMultipleUsersData({ payload, site_id: this.site_id });

      this.enableNextMultipleUserTypeBtn = false;
      this.showRowStatus = false;

      this.isMultipleUserType = this.getMultipleUsersData?.length > 1;

      this.multipleUsersData = this.getMultipleUsersData[0];

      this.tableData = JSON.parse(
        JSON.stringify(this.getMultipleUsersData[0].users)
      );

      this.columnsDisplayCheck();

      this.isLoaded = true;
    },
    handleCovidType(vaccine_pcr) {
      switch (vaccine_pcr.vaccine_pcr) {
        case "vaccine":
          return "covid_vaccine";
        case "pcr":
          return "covid_pcr";
        default:
          break;
      }
    },
    columnsDisplayCheck() {
      this.showHostColumnTemp = false;
      this.temperature_check = false;
      this.mask_check = false;
      this.showPrintBadgeColumn = false;

      // check if any selected user has note
      this.tableData.filter((user) => {
        if (user.notes?.length) this.showNoteColumnTemp = true;
      });

      //check if any selected user has checks
      let temperature_check, mask_check;
      this.tableData.forEach((user) => {
        if (user.signedOut && user.checksModel)
          this.showChecksColumnTemp = true;
        if (user.signedOut && user.hostModel) this.showHostColumnTemp = true;
        if (user.signedOut && user.checksModel && user.checksModel?.temperature)
          temperature_check = true;
        if (user.signedOut && user.checksModel && user.checksModel?.mask)
          mask_check = true;

        const printBadeExists = user.checks?.find(check => check.name == "print_badge");
        const loginMode = printBadeExists?.metadata && JSON.parse(printBadeExists.metadata);
        let isSignIn;
        let isSignOut; 
        let isCheckIn;
          if (loginMode?.loginMode) {
            isSignIn = loginMode.loginMode.includes(3);
            isSignOut = loginMode.loginMode.includes(4);
            isCheckIn = loginMode.loginMode.includes(1);
          }
        if (!user.all && printBadeExists && printBadeExists.value == 1 && !user.is_default_user && 
          ((this.getMultipleUsersData[0].area.login_mode == "checkIn_only" && isCheckIn) ||
          (this.getMultipleUsersData[0].area.login_mode == "signIn_signOut" && !user.signedOut && isSignOut) ||
          this.getMultipleUsersData[0].area.login_mode == "signIn_signOut" && user.signedOut && isSignIn)
        ) {
          this.showPrintBadgeColumn = true;
          user.printBadge = false;
        } else user.printBadge = "-";
        // console.log("user", user);
      });

      //Remove any compliance that is not required for all users
      this.tableData[0]?.complinaces?.forEach((massActioncompliance) => {
        //If compliance is not required in "mass action" row then
        // remove it from all rows
        if (!massActioncompliance.isRequired) {
          this.tableData?.forEach((user) => {
            user.complinaces = user.complinaces?.filter((compliance) => {
              return compliance.id != massActioncompliance.id;
            });
          });
        }
      });

      //Checks displayed label value
      this.checksColumnName =
        temperature_check && mask_check
          ? this.$tc("signInOut.tempAndMask", 1)
          : temperature_check
          ? this.$t("common.temperature")
          : mask_check
          ? this.$t("common.mask")
          : null;

      this.displayHostMasActionAddButton =
        this.tableData.filter((userData) => userData.signedOut && !userData.all)
          ?.length > 0;
    },
  },

  beforeMount() {
    this.resultSet = new Set();

    //To keep track of users ids (in case of multiple user types)
    this.allUsersBeforeMountData = this.getMultipleUsersData;

    this.isMultipleUserType = this.getMultipleUsersData?.length > 1;

    this.multipleUsersData = this.getMultipleUsersData[0];

    this.tableData = cloneDeep(this.getMultipleUsersData[0].users);

    this.site_id = this.tableData[0].site_id;

    this.columnsDisplayCheck();

    this.displayHostMasActionAddButton =
      this.tableData.filter((userData) => userData.signedOut && !userData.all)
        ?.length > 0;

    this.isLoaded = true;
  },
  beforeCreate() {
    // Redirect to dashboard if user access page by typing route url
    if (!this.$router?.history?.current?.params?.multipleSignin) {
      window.location.href = "/";
    }
  },

  destroyed() {
    this.clearMultipleUsersData();
    this.$v.$reset();
    this.allUsersBeforeMountData = null;
    this.massActionIsStarted = false;
    this.showRowStatus = false;
  },
};
window.onbeforeunload = function () {
  let vuex = JSON.parse(localStorage.getItem("vuex"));
  vuex.dailyLogbook.multipleUsersData = {};
  localStorage.setItem("vuex", JSON.stringify(vuex));
};
</script>

<style lang="scss">
.nowrap {
  white-space: nowrap;
}
.print-badge-cell {
  padding: 0 24px !important;
}
.apply-for-all-spinner {
  width: 15px;
  height: 15px;
  color: #fff !important;
  border: 0.15em solid currentcolor;
  border-right-color: transparent;
}
.stop-spinner{
  border-right-color: #fff;
}
.reason-cell {
  .multiselect__tags {
    width: 160px !important;
  }
}
.massaction-page-title-container {
  margin-top: 25px;
  margin-inline-start: 22px;
  display: flex;
}
.next-user-type-btn {
  width: 127px;
  height: 27px;
  border: 0;
  border-radius: 13.5px;
  background-color: #103f5e;

  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  margin-inline-start: 45px;
}
.next-user-type-btn:lang(ar) {
  height: fit-content;
  padding: 5px;
}
.next-user-type-btn:disabled {
  opacity: 0.4 !important;
}
.multiple-users-success-note {
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: start;
  color: #939393de;
  opacity: 0.87 !important;
}
.massaction-page-title {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  margin-top: 5px;
}
ul.single-action-errors-list {
  margin-bottom: 0px !important;
}
.apply-btn {
  height: 28px;
  width: 135px;
  border: 0;
  border-radius: 13.5px;
  margin-top: 10px;
  background-color: #2680eb;

  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
}
.apply-btn:disabled {
  opacity: 0.4 !important;
}
.multipleSigninAction {
  .md-content.md-table-content.md-scrollbar.md-theme-default {
    overflow: hidden !important;
  }
  .page-container {
    margin-inline-start: 12px;
    margin-top: 20px;
    min-height: 80vh;
    background-color: #fff;
    border-radius: 8px;

    .page-header {
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
      padding-top: 10px;
      padding-inline-end: 25px;
      padding-bottom: 0;
      padding-inline-start: 0;
      color: #939393de;
    }
    .page-content {
      padding: 0;
    }
    .fillin-btn {
      background: #103f5e;
      width: 70px;
      height: 25px;
      border: 0;
      border-radius: 12.5px;
      color: #fff;

      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: center;
      margin-top: 5px;
    }
    .fillin-btn:disabled {
      opacity: 0.4 !important;
    }
    table {
      overflow: auto;
      border-top: 1px solid #f2f2f2;
      border-bottom: 1px solid #f2f2f2;
    }
    .md-table-cell,
    .md-table-head {
      border-inline-end: 1px solid #f2f2f2;
    }
    tbody .md-table-row td,
    .md-table-head-container {
      margin-inline-end: -0.5px;
    }
    tbody .md-table-row td {
      border-top: 1px solid #f2f2f2;
      padding: 2px;
    }
    .md-table {
      width: auto;
    }

    .default-text-style,
    .md-table-head-label {
      font-weight: 400;
      letter-spacing: 0em;
      text-align: start;
    }
    .md-table-head-label {
      font-size: 14px;
      line-height: 17px;
      color: #939393;
    }
    .default-text-style {
      font-size: 16px;
      line-height: 19px;
      color: #495057;
      // width: 110%;
      // text-align: center;
      max-width: 500px;
      overflow-wrap: break-word;
    }
    .error-text-style {
      font-weight: 600;
      letter-spacing: 0em;
      text-align: start;
      color: #f46a6a;
    }
    .w-480 {
      min-width: 480px;
    }
    .checks-value {
      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: start;
      color: #495057;
      width: 145px;
      margin: 13px 0 10px 0;
    }
    .host-value {
      margin: 13px 0 10px 0;

      // font-size: 16px;
      font-weight: 400;
      line-height: 19px;
    }
    .md-table-cell-container {
      min-width: 150px;
    }
  }
  .cell-min-height {
    min-height: 35px;
  }
  .status-completed,
  .status-in-progress,
  .status-pending {
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
  }
  .status-completed {
    color: #34c38f;
  }
  .status-in-progress {
    color: #2680eb;
  }
  .status-pending {
    color: #ffa500;
  }
  .full-opacity {
    opacity: 1 !important;
    width: 104px !important;
    height: 27px !important;
  }
  .multiselect__content-wrapper {
    width: 175px !important;
    margin-top: 5px !important;
    border-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border-bottom: none !important;
    border-inline-start: none !important;
    border-inline-end: none !important;
    max-height: 125px !important;
    font-size: 16px !important;
    font-weight: 400 !important;
    color: #787878 !important;
  }

  .valid-multiselect .multiselect--active {
    border: 2px solid var(--main-clr);
    margin-inline-start: -2px;
  }
  .invalid-multiselect {
    width: 169px !important;
    border: 2px solid #f46a6a !important;
    border-radius: 5px !important;
  }
  .reason-cell .md-table-cell-container {
    padding: unset !important;
    max-width: 175px !important;
  }

  .md-table-head-label {
    padding-inline-start: 24px;
    padding-inline-end: 22px;
  }

  .md-table-cell-container {
    padding: 6px 24px 6px 24px;
  }
}
section.multipleSigninAction .tooltip .tooltip-inner {
  padding: 10px;
  border-radius: 6px;
  background-color: #f46a6a !important;

  font-weight: 600 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  text-align: center;
  color: #ffffff !important;
  min-width: 123px;
  transition: none !important;
}
.bs-tooltip-top.b-tooltip-danger {
  margin-bottom: 10px !important;
  transition: none !important;
}

.arrow {
  display: none !important;
}

.bs-tooltip-bottom.b-tooltip-danger {
  top: -80px !important;
  inset-inline-start: 22px !important;
  transition: none !important;
  will-change: opacity !important;
}

.section-field {
  font-weight: 400;
  font-size: 16px;
  line-height: 19.2px;
  margin-bottom: 12px;
  margin-top: 13px;
}
</style>
